import { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { RadioButton } from 'primereact/radiobutton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { BUTTON_STYLES } from '../constants';

class OldFeeInfoDialog extends Component {
    renderHeader = () => {
        const { onBack } = this.props;
        
        return (
            <div className='flex align-items-center text-center text-black-alpha-80'>
                <span 
                    className="back-arrow-icon"
                    onClick={onBack}
                >
                    <i className="pi pi-arrow-left" style={{ fontSize: '1.5rem', color: '#333' }}></i>
                </span>
                <h3 style={{ margin: 0, flex: 1 }}>Category Change Summary</h3>
            </div>
        );
    };

    renderFooter = () => {
        const { totalClosingAdvance, totalClosingDueAmt, onShowNewFeeInfo, onCancel } = this.props;
        
        return (
            <div className="flex flex justify-content-center my-3">
                {totalClosingAdvance >= totalClosingDueAmt && (
                    <Button
                        className="formAddButton px-4 mr-2"
                        style={BUTTON_STYLES.APPROVE}
                        onClick={onShowNewFeeInfo}
                    >
                        <p className="formAddButtonText">New Fee Types</p>
                    </Button>
                )}
                <Button 
                    className="cancelButtonn" 
                    style={{ width: "164px", height: "48px" }} 
                    onClick={onCancel}
                >
                    <p className="cancelButtonnText">Cancel</p>
                </Button>
            </div>
        );
    };

    renderAdvanceAdjustmentSection = () => {
        const { advanceAdjustmentType, isManualAdjustment, onAdjustmentTypeChange } = this.props;
        
        return (
            <div className="p-4 mt-3 border-1 border-round-lg surface-border">
                <div className="flex align-items-center justify-content-between mb-3">
                    <div className="flex align-items-center">
                        <h3 className="m-0 text-xl font-semibold">Advance Adjustment Options</h3>
                    </div>
                    <div className="flex align-items-center gap-2">
                        <div className="flex align-items-center gap-2 mr-4">
                            <RadioButton
                                inputId="systemAdjustment"
                                name="adjustmentType"
                                value="system"
                                onChange={(e) => onAdjustmentTypeChange('system', false)}
                                checked={!isManualAdjustment}
                            />
                            <label htmlFor="systemAdjustment" className="font-medium text-color">System</label>
                        </div>
                        <div className="flex align-items-center gap-2">
                            <RadioButton
                                inputId="manualAdjustment"
                                name="adjustmentType"
                                value="manual"
                                onChange={(e) => onAdjustmentTypeChange('manual', true)}
                                checked={isManualAdjustment}
                            />
                            <label htmlFor="manualAdjustment" className="font-medium text-color">Manual</label>
                        </div>
                    </div>
                </div>
                <div className="p-3 bg-gray-50 border-round">
                    <div className="flex align-items-center">
                        <i className="pi pi-info-circle mr-2" style={{ color: '#0288d1' }}></i>
                        <span className="text-sm">
                            {isManualAdjustment
                                ? "You have selected to manually adjust the advance amount. This gives you control over how the advance will be applied."
                                : "The system will automatically adjust the advance based on optimal distribution."}
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    renderStatusMessage = () => {
        const { totalClosingAdvance, totalClosingDueAmt } = this.props;
        
        return (
            <div className="mt-2">
                {totalClosingAdvance >= totalClosingDueAmt ? (
                    <div className="flex align-items-center mt-2">
                        <i className="pi pi-info-circle mx-2"></i>
                        <span className="info-text" style={{ fontSize: "14px", color: "#268900" }}>
                            Sufficient advance is available to clear all dues. The remaining advance balance after settlement will be ₹{(totalClosingAdvance - totalClosingDueAmt).toFixed(2)}.
                        </span>
                    </div>
                ) : (
                    <div className="flex align-items-center mt-2">
                        <i className="pi pi-exclamation-triangle mx-2" style={{ color: '#BF0031' }}></i>
                        <span className="info-text" style={{ fontSize: "14px", color: '#BF0031' }}>
                            Available advance is not sufficient to clear all dues. Please ensure the pending amount of ₹{(totalClosingDueAmt - totalClosingAdvance).toFixed(2)} is paid before proceeding.
                        </span>
                    </div>
                )}
            </div>
        );
    };

    render() {
        const { 
            visible, 
            onHide, 
            oldFeeInfo, 
            totalClosingDueAmt, 
            totalClosingAdvance 
        } = this.props;

        return (
            <Dialog
                visible={visible}
                style={{ width: '80%', height: "80%" }}
                header={this.renderHeader}
                showGridlines
                draggable={false}
                closable={true}
                onHide={onHide}
                footer={this.renderFooter}
            >
                <div className="card datatable-crud-demo">
                    <DataTable
                        className='dataTableValuesText'
                        value={oldFeeInfo?.feeInfo}
                    >
                        <Column 
                            field="feeType" 
                            header="Fee Type" 
                            style={{ width: "15rem", height: "6rem" }} 
                            alignHeader={"center"} 
                            headerClassName="text-color-secondary" 
                            bodyClassName='text-center' 
                        />
                        <Column 
                            field="totalFee" 
                            header="Actual Fee"
                            body={(rowData) => (
                                <span>{parseFloat(rowData?.totalFee || 0).toFixed(2)}</span>
                            )}
                            style={{ width: "15rem", height: "6rem" }} 
                            alignHeader={"center"} 
                            headerClassName="text-color-secondary" 
                            bodyClassName='text-center' 
                        />
                        <Column 
                            field="amountPaid" 
                            header="Actual Amount Paid"
                            body={(rowData) => (
                                <span>{parseFloat(rowData?.amountPaid || 0).toFixed(2)}</span>
                            )}
                            style={{ width: "15rem", height: "6rem" }} 
                            alignHeader={"center"} 
                            headerClassName="text-color-secondary" 
                            bodyClassName='text-center' 
                        />
                        <Column 
                            field="closingAmount" 
                            header="Amount To Be Deducted"
                            body={(rowData) => (
                                <span>{parseFloat(rowData?.closingAmount || 0).toFixed(2)}</span>
                            )}
                            style={{ width: "15rem", height: "6rem" }} 
                            alignHeader={"center"} 
                            headerClassName="text-color-secondary" 
                            bodyClassName='text-center' 
                        />
                        <Column 
                            field="" 
                            header="Amount Paid"
                            body={(rowData) => (
                                <span>{(parseFloat(rowData?.closingAmount || 0) - parseFloat(rowData?.closingDueAmt || 0)).toFixed(2)}</span>
                            )}
                            style={{ width: "15rem", height: "6rem" }} 
                            alignHeader={"center"} 
                            headerClassName="text-color-secondary" 
                            bodyClassName='text-center'
                        />
                        <Column 
                            field="closingDueAmt" 
                            header="Due"
                            body={(rowData) => (
                                <span>{parseFloat(rowData?.closingDueAmt || 0).toFixed(2)}</span>
                            )}
                            style={{ width: "15rem", height: "6rem" }} 
                            alignHeader={"center"} 
                            headerClassName="text-color-secondary" 
                            bodyClassName='text-center' 
                        />
                    </DataTable>
                </div>

                <div className="flex justify-content-end mt-4 p-4 border-round-lg bg-gray-50">
                    <div className="flex gap-6">
                        <div className="flex align-items-center gap-2">
                            <span className="font-bold text-xl" style={{ color: "#076EFF" }}>Closing Amount:</span>
                            <span className="text-xl">₹{
                                oldFeeInfo?.feeInfo?.reduce(
                                    (acc, curr) => acc + (curr.closingAmount || 0), 0
                                ).toFixed(2)}</span>
                        </div>
                        <div className="flex align-items-center gap-2">
                            <span className="font-bold text-xl" style={{ color: "#076EFF" }}>Amount Paid:</span>
                            <span className="text-xl">₹{
                                oldFeeInfo?.feeInfo?.reduce(
                                    (acc, curr) => acc + (curr.closingAmount - curr.closingDueAmt), 0
                                ).toFixed(2)}</span>
                        </div>
                        <div className="flex align-items-center gap-2">
                            <span className="font-bold text-xl" style={{ color: "#076EFF" }}>Due Amount:</span>
                            <span className="text-xl">
                                {totalClosingAdvance > totalClosingDueAmt
                                    ? "₹0.00"
                                    : `₹${(totalClosingDueAmt - totalClosingAdvance).toFixed(2)}`}
                            </span>
                        </div>
                        <div className="flex align-items-center gap-2">
                            <span className="font-bold text-xl" style={{ color: "#076EFF" }}>Advance:</span>
                            <span className="text-xl">₹{
                                totalClosingAdvance > totalClosingDueAmt
                                    ? (totalClosingAdvance - totalClosingDueAmt).toFixed(2)
                                    : "0.00"
                            }</span>
                        </div>
                    </div>
                </div>

                {this.renderAdvanceAdjustmentSection()}
                {this.renderStatusMessage()}
            </Dialog>
        );
    }
}

export default OldFeeInfoDialog;
